module.exports = __webpack_public_path__ + "media/images/top/img_pickup_orenoikirumichi-e79b509cdd16abc1ed6246004d398caa.webp";